import { Container } from "aurelia-dependency-injection";
import { AppEvents } from "./../../app-events";
import { JurisdictionFiltersView } from "./jurisdiction-filters";
import { SearchDownloadModel, DownloadMode } from "./../models/search-download";
import { GenericDownloadView } from "./../../desktop/views/partials/generic-download";
import { MaterialFilterView } from "./material-filter";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import { SearchModel} from "../models/search";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("./jurisdiction-filter-panel.html");

@backboneViewProperties({
    template: template,
    tagName: "div",
    className: "jurisdiction-filter-panel",
})
export class JurisdictionFilterPanelView extends Marionette.LayoutView<any> {

    public model: SearchModel;
    private childrenRegion: Marionette.Region;

    constructor(options?: any) {
        super(options);
        this.setupModelListeners();
    }

    public regions(): any {
        const regions = {
            childrenRegion: ".children-region"
        };

        return regions;
    }

    public onShow() {
        if (this.childrenRegion) {
            this.childrenRegion.show(new JurisdictionFiltersView({collection: this.model.JurisdictionOverrides}));
            this.updateDisplay(!this.model.DisableJurisdictionFiltering);
        }
        this.listenTo(this.model.JurisdictionOverrides, "change:Ticked", this.childChanged);
        this.setUseSettingsInitialState();
    }

    public childChanged() {

        let allCheckboxVal = false;

        if (this.model.JurisdictionOverrides.all((f) => !f.Ticked)) {
            allCheckboxVal = true;
        }

        _.defer(() => {
            this.$(".use-settings-link").find("input").prop("checked", allCheckboxVal);
        });
    }

    public events(): Backbone.EventsHash {

        const events = {};

        events["click .use-settings-link"] = (e) => this.useSettingsClicked(e);
        events["click .open-settings"] = (e) => this.openSettingsMenu(e);
        return events;
    }

    public openSettingsMenu(e) {
        e.stopPropagation();
        const appEvents = ContainerHelper.Events;
        appEvents.trigger(AppEvents.SettingsVisibilityToggled);
    }

    public useSettingsClicked(e: JQueryEventObject) {
        let anyChanged = false;
        this.model.JurisdictionOverrides.forEach((j) => {
            if (j.Ticked) {
                anyChanged = true;
            }
            j.Ticked = false;
        });

        if (anyChanged) {
            _.defer(() => {
                this.model.setPage(1);
                this.model.emitSearchRequest();
            });
        }
    }

    private setUseSettingsInitialState() {
        const anyTicked = this.model.JurisdictionOverrides.any((j) => j.Ticked);

        this.$(".use-settings-link").find("input").prop("checked", !anyTicked);
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:DisableJurisdictionFiltering", this.disableJurisdictionFilteringChanged);
    }

    private updateDisplay(show) {
        if (this.childrenRegion) {
            this.$(".disabled-shield").toggle(!show);
        }
    }

    private disableJurisdictionFilteringChanged(model, prop) {
       this.updateDisplay(!prop);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/jurisdiction-filter-panel.ts